import React from "react";

import { IconButton as MuiIconButton } from "@mui/material";
import clsx from "clsx";

import {
  useOutlinedIconButtonStyles,
  useIconButtonStyles,
  useOutlinedBorderWidthStyles,
} from "./base/styles";
import { BaseVariantIconButtonProps } from "./base/types";

export const OutlinedIconButton: React.FC<BaseVariantIconButtonProps> = ({
  size = "default",
  icon,
  variant = "primary",
}) => {
  const { classes: iconButtonClasses } = useIconButtonStyles();
  const { classes: borderWidthClasses } = useOutlinedBorderWidthStyles();
  const { classes: variantClasses } = useOutlinedIconButtonStyles();

  const getButtonStyles = () => {
    let className;
    let muiSize: "small" | "medium" | "large" = "medium";

    switch (size) {
      case "tiny":
        className = clsx(iconButtonClasses.tiny, borderWidthClasses.tiny);
        break;
      case "smallest":
        className = clsx(
          iconButtonClasses.smallest,
          borderWidthClasses.smallest
        );
        break;
      case "smaller":
        className = clsx(iconButtonClasses.smaller, borderWidthClasses.smaller);
        muiSize = "medium";
        break;
      case "small":
        className = borderWidthClasses.small;
        muiSize = "small";
        break;
      case "default":
        className = borderWidthClasses.default;
        muiSize = "medium";
        break;
      case "large":
        className = borderWidthClasses.large;
        muiSize = "large";
        break;
      case "larger":
        className = clsx(iconButtonClasses.larger, borderWidthClasses.larger);
        muiSize = "large";
        break;
    }

    return { className, muiSize };
  };

  const getButtonColors = () => {
    switch (variant) {
      case "error":
        return variantClasses.error;
      case "warning":
        return variantClasses.warning;
      case "neutral":
        return variantClasses.neutral;
      case "primary":
      default:
        return variantClasses.primary;
    }
  };

  const { className, muiSize } = getButtonStyles();

  return (
    <MuiIconButton
      className={clsx(className, getButtonColors())}
      size={muiSize}
    >
      {icon}
    </MuiIconButton>
  );
};
